// Regra do acesso offline, porte de farma-platform/apps/farmabolso-mobile/src/lib/offline.ts.

/**
 * Quanto tempo o conteúdo pode ser consultado sem o servidor confirmar o acesso.
 * É regra de negócio, não detalhe de sessão: a compra tem sete dias de
 * garantia, e um reembolso precisa derrubar o acesso.
 */
export const OFFLINE_ACCESS_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export type MetaOffline = {
  schemaVersion: 1;
  /** Versão da release salva. */
  versao: string;
  contaId: string;
  /** Validade da última sessão conhecida, em ms. */
  expiraEm: number;
  salvoEm: number;
  /** Última vez que o servidor confirmou o acesso. */
  confirmadoEm: number;
  /**
   * Maior instante já observado neste aparelho. Sem esse piso, atrasar o
   * relógio do sistema estenderia o acesso offline indefinidamente.
   */
  vistoEm: number;
  /** Versão de cada coleção salva, para baixar só as que mudaram. */
  colecoes: Record<string, string>;
};

/** O relógio do aparelho é do usuário, e pode andar para trás. */
export const agoraEfetivo = (meta: Pick<MetaOffline, "vistoEm">, now = Date.now()) => Math.max(now, meta.vistoEm ?? 0);

/** O relógio voltou para antes do último instante visto. */
export const relogioVoltou = (meta: Pick<MetaOffline, "vistoEm">, now = Date.now()) => now < (meta.vistoEm ?? 0) - 60_000;

/**
 * A base salva vale enquanto o servidor ainda considerava a sessão válida e faz
 * menos de uma janela desde a última confirmação.
 */
export function baseUtilizavel(meta: Pick<MetaOffline, "vistoEm" | "expiraEm" | "confirmadoEm">, now = Date.now()) {
  return agoraEfetivo(meta, now) < Math.min(meta.expiraEm, meta.confirmadoEm + OFFLINE_ACCESS_WINDOW_MS);
}

/** Coleções a baixar: as novas e as que mudaram de versão. */
export function colecoesAlteradas(salvas: Record<string, string> | undefined, remotas: Record<string, string>) {
  return Object.entries(remotas)
    .filter(([nome, v]) => salvas?.[nome] !== v)
    .map(([nome]) => nome);
}
